import { createSlice } from "@reduxjs/toolkit";
import { ChatUser } from "../../api/user-request";

export const initialState: { value: ChatUser | null } = { value: null };

export const selectedUserSlice = createSlice({
  name: "selectedUser",
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setSelectedUser } = selectedUserSlice.actions;

export default selectedUserSlice.reducer;
